import { useStyletron } from '@thanx/uikit/theme'
import Badge from 'components/Badge'
import { buildTranslate } from 'locales'
import { Fields as CardFields } from 'models/Card'
import React from 'react'
import {
  BadgeAppearance,
  badgeStyle,
  UNAVAILABLE_APPEARANCE,
} from './badgeAppearance'

const t = buildTranslate('users.view.cards')

type CardBadgeState = CardFields['state'] | CardFields['payment_state']

type PropsT = {
  state: CardBadgeState
}

function stateAppearance(state: CardBadgeState): BadgeAppearance {
  const labelKey = `badge.${state}`
  switch (state) {
    case 'unlinked':
    case 'payment_unlinked':
      return { labelKey, tone: 'neutral' }
    case 'linked':
    case 'payment_linked':
      return { labelKey, tone: 'positive' }
    case 'expired':
    case 'payment_expired':
      return { labelKey, tone: 'warning' }
    case 'errored':
    case 'payment_errored':
      return { labelKey, tone: 'negative' }
    case 'archived':
    case 'payment_archived':
      return { labelKey, tone: 'muted' }
    default:
      return UNAVAILABLE_APPEARANCE
  }
}

const StatusBadge = ({ state }: PropsT) => {
  const [css] = useStyletron()
  const { labelKey, tone } = stateAppearance(state)

  return (
    <Badge value={t(labelKey)} className={`ml-xs ${css(badgeStyle(tone))}`} />
  )
}

export default StatusBadge
